module.exports = __webpack_public_path__ + "img/distinctions/image-06.jpg";